export * from './venueTransferRoutesController.service';
import { VenueTransferRoutesControllerService } from './venueTransferRoutesController.service';
export * from './venueTransfersController.service';
import { VenueTransfersControllerService } from './venueTransfersController.service';
export const APIS = [VenueTransferRoutesControllerService, VenueTransfersControllerService];
